import { render } from "./ChuThichDoc.vue?vue&type=template&id=c5040b26&scoped=true"
import script from "./ChuThichDoc.vue?vue&type=script&lang=js"
export * from "./ChuThichDoc.vue?vue&type=script&lang=js"

import "./ChuThichDoc.vue?vue&type=style&index=0&id=c5040b26&lang=scss&scoped=true"
import "./ChuThichDoc.vue?vue&type=style&index=1&id=c5040b26&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5040b26"]])

export default __exports__